// extracted by mini-css-extract-plugin
export default {"chipsContainer":"Participant_chipsContainer__B3uL7","container":"Participant_container__23dBo"};